import React from 'react'
import { Tooltip } from '@material-ui/core'
import { Schedule } from '../../../models'
import { useSchedulerHeaderStyles } from './styles'
import { Container } from '../../../components'
import { DateRange } from '@material-ui/icons'
import { DateTime } from 'luxon'

interface Props {
    schedule?: Schedule
    startDate?: DateTime
    endDate?: DateTime
    setIsSpreadsheetView: (value: boolean) => void
    refreshWorkorders: () => void
    clickSchedule: () => void
    clickScheduleReview: () => void
    scheduleReviewEnabled: boolean
}

export const ScheduleHeaderTitle = (props: Props) => {
    const { schedule, startDate, endDate } = props
    const classes = useSchedulerHeaderStyles()

    const scheduleName = schedule?.name ?? ''
    const scheduleId = schedule?.schedule_id ?? ''

    const dateRangeText =
        startDate && endDate
            ? `${startDate.toFormat('MMM d, yyyy')} — ${endDate.toFormat(
                  'MMM d, yyyy',
              )}`
            : ''
    return (
        <Container className={classes.scheduleHeaderTitle}>
            {/* Title Row */}
            <div className={classes.titleRow}>
                <Tooltip title={scheduleName}>
                    <span className={classes.titleText}>{scheduleName}</span>
                </Tooltip>
                {scheduleId && (
                    <>
                        <span className={classes.titleDot}>•</span>
                        <span className={classes.titleMeta}>{scheduleId}</span>
                    </>
                )}
            </div>

            {/* Dates Row */}
            <div className={classes.metaRow}>
                {dateRangeText && (
                    <span className={classes.dateRange}>
                        <DateRange />
                        {dateRangeText}
                    </span>
                )}
            </div>
        </Container>
    )
}
